import { RouteLocation } from '@/api/useFreight/useOrderRouteLog'
import dayjs from 'dayjs'

/**
 * Formats a time window into a user-friendly string
 *
 * @param start - The start date/time
 * @param end - The end date/time
 * @returns A formatted string, e.g. "30 MIN"
 */
export function formatTimeWindow(start?: string | null, end?: string | null): string | null {
  if (!start || !end) return null // Default value if dates are missing

  const startTime = dayjs(start)
  const endTime = dayjs(end)
  const diffMinutes = Math.abs(endTime.diff(startTime, 'minute'))

  return `${diffMinutes} MIN`
}

export function formatAddress(drop: RouteLocation): string {
  const address = drop.address
  const city = drop.city
  const state = drop.state
  if (!address && !city && !state) return 'Address unavailable'

  const parts = [address, city, state].filter(Boolean)
  return parts.join(', ')
}
